import RichTextHtmlElement from 'shared/components/FormKitBuilderContainer/FormElements/RichTextHtmlElement.vue';
import { plugin, defaultConfig } from "@formkit/vue";
import { iconCheckmark, iconRadio, iconSearch } from "@coloplast/design-system/dist/exports/icons";
import { createProPlugin, mask, autocomplete, dropdown, taglist } from '@formkit/pro'
import scrollToErrors from 'multisite/formkit.config';
import maskLengthValidation from 'shared/components/FormKitBuilderContainer/formkitMask.config'
import "@coloplast/design-system/dist/components/formkit/formkit.css";
import { generateClasses } from "@formkit/themes";

export function initFormKitSchema(app) {

	const proPlugin = createProPlugin('fk-570552d805b', {
		mask,
		autocomplete,
		dropdown,
		taglist
	});

	app.component('RichTextHtmlElementCmp', RichTextHtmlElement);
	app.use(
		plugin,
		defaultConfig({
			/* You'll need to register the design system icons you'd like to use in the FormKit inputs */
			icons: {
				check: iconCheckmark,
				search: iconSearch,
                checkboxDecorator: iconCheckmark,
                radioDecorator: iconRadio,
			},
			plugins: [proPlugin, scrollToErrors, maskLengthValidation],
			config: {
				classes: generateClasses({
					/* We reset button and submit styles, and instead point them to the design system button classes */
					button: {
						input: "$reset ds-button ds-button--primary",
					},
					submit: {
						input: "$reset ds-button ds-button--primary",
					},
				}),
			}
		}),
	);
}

